import * as React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { DialogMUI } from '../../pages/recommendations/Recommendations'

const Background = styled.div`
  background-color: #fff;
  overflow: hidden;
  padding: 4px;
`

const Title = styled.p`
  color: var(--text-main, #1a1a1a);
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0.4px;
  margin: 0 0 16px 0;
`

const Paragraph = styled.p`
  color: var(--text-main, #1a1a1a);
  font-family: Roboto;
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
  letter-spacing: 0.28px;
  margin: 0 0 20px 0;
`

const OkButton = styled.button`
  display: block;
  width: 100%;
  max-width: 200px;
  margin: 0 auto;
  padding: 10px 20px;
  background: #3baab0;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #329a9e;
  }
`

const DesktopRecommendedContent = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation()

  return (
    <Background className="paddModal" data-animch={3}>
      <Title>{t('desktopRecommendedTitle')}</Title>
      <Paragraph>{t('desktopRecommendedDescription')}</Paragraph>
      <OkButton type="button" onClick={onClose}>
        {t('ok')}
      </OkButton>
    </Background>
  )
}

const MOBILE_BREAKPOINT = 768
const SESSION_STORAGE_KEY = 'desktopRecommendedDismissed'

export const DesktopRecommendedModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  return (
    <DialogMUI
      scroll="body"
      aria-labelledby="desktop-recommended-title"
      aria-describedby="desktop-recommended-description"
      onClose={onClose}
      open={open}
    >
      <DesktopRecommendedContent onClose={onClose} />
    </DialogMUI>
  )
}

export const DesktopRecommendedBanner = () => {
  const location = useLocation()
  const [open, setOpen] = React.useState(false)
  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])

  React.useEffect(() => {
    if (!isMobile) {
      setOpen(false)
      return
    }
    const dismissed = sessionStorage.getItem(SESSION_STORAGE_KEY)
    if (dismissed) {
      setOpen(false)
      return
    }
    setOpen(true)
  }, [isMobile, location.pathname])

  const handleClose = React.useCallback(() => {
    sessionStorage.setItem(SESSION_STORAGE_KEY, '1')
    setOpen(false)
  }, [])

  if (!open) return null

  return (
    <DialogMUI
      scroll="body"
      aria-labelledby="desktop-recommended-title"
      aria-describedby="desktop-recommended-description"
      onClose={handleClose}
      open={open}
    >
      <DesktopRecommendedContent onClose={handleClose} />
    </DialogMUI>
  )
}

export default DesktopRecommendedModal
